module.exports = __webpack_public_path__ + "img/photo-0009.e71fc33f.jpg";